import React from 'react';
import { images, importAllImages } from '../utils/importImages';

// const FilmAndTv = ({name}) => {
//   return <h1>Hello, {name}!</h1>;
// };


const FilmAndTv = ({title, 
                    role,
                    year,
                    production,
                    festivals,
                    separator,
                    url,
                    images, image, 
                    honour1 = "", honour2 = "", honour3 = "", 
                    honour1Height = 60, honour2Height = 60, honour3Height = 60}) => {


  return (
    <>
      <tr>
        <td>
          <a href={url}>
            <img src={images[image]} className="imgthumb" />
          </a>
        </td>
        <td colspan="1">
          <h4>{title}</h4> ({role})<br />
          <div style={{ whiteSpace: "nowrap" }}>{production}</div><br/>
          {year}<br />
          {festivals && <div>(Submitted for festivals)</div>}
        </td>
        <td>
          {honour1 != "" && <img height={honour1Height} src={images[honour1]} alt="Laurels" className="imggift" />}{honour3 == "" && <br />}
          {honour2 != "" && <img style={{ marginLeft: "4px" }} height={honour2Height} src={images[honour2]} alt="Laurels" className="imggift" />}
          {honour3 != "" && <img style={{ marginLeft: "4px" }} height={honour3Height} src={images[honour3]} alt="Laurels" className="imggift" />}
        </td>
      </tr>
      {separator && <tr style={{ height: "1px" }}><td colspan="3"><hr className="hrblue" /></td></tr>}
    </>
  );

};




export default FilmAndTv;